var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratePdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,17v3H5v-3H3.5v3l0,0c0,0.8,0.7,1.5,1.5,1.5h12c0.8,0,1.5-0.7,1.5-1.5l0,0v-3H17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.7,14.7 13.7,13.7 11.7,15.6 11.7,9.5 10.3,9.5 10.3,15.6 8.3,13.7 7.3,14.7 11,18.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20,2 20,0.5 15.5,0.5 15.5,8 17,8 17,5 19.2,5 19.2,3.5 17,3.5 17,2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,8h-3V0.5h3c1.2,0,2.2,1,2.2,2.2v3C14,7,13,8,11.7,8z M10.3,6.5h1.5c0.4,0,0.7-0.3,0.7-0.7v-3c0-0.4-0.3-0.7-0.7-0.7 h-1.5V6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,0.5H2V8h1.5V5.8h2.2c0.8,0,1.5-0.7,1.5-1.5V2C7.3,1.2,6.6,0.5,5.8,0.5z M3.5,4.3V2h2.2l0,2.2H3.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: -0.9,
    y: -0.9,
    className: "st0",
    width: 23.9,
    height: 23.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratePdfIcon);
export default __webpack_public_path__ + "static/media/generate_pdf_icon.8e9c965230a112137180a008ec86f4eb.svg";
export { ForwardRef as ReactComponent };